import { component as defineComponent } from 'flightjs';

export default defineComponent(function() {
    this.after('initialize', function() {
        this.on(this.$node, 'click', this.autoSelect);
    });

    this.autoSelect = function(e) {
        this.$node[0].setSelectionRange(0, e.currentTarget.value.length);
    };
});



// WEBPACK FOOTER //
// ./src/web/js/app/ui/auto-select-input.js